<script>
    export default {

        props: {
            cartItems: {
                required: true,
                default: function () {
                    return {};
                }
            },
            cartId: {
                required: true,
            }
        },

        data() {
            return {
                items: {},
                paypalClient: {
                    sandbox: window.App.paypal.clientIdSandbox,
                    production: window.App.paypal.clientIdSandbox
                },
                paypalStyling: {
                    layout: 'vertical',   // horizontal | vertical
                    size: 'responsive',   // medium | large | responsive
                    shape: 'rect',         // pill | rect
                    color: 'blue',         // gold | blue | silver | black,
                    fundingicons: false,    // true | false,
                    tagline: false          // true | false,
                },
                paypalFunding: {
                    allowed: [
                        paypal.FUNDING.CARD,
                        paypal.FUNDING.CREDIT
                    ],
                    disallowed: []
                },
                paypalTransactionDescription: "Donating to Kinds in need Foundation."
            }
        },

        computed: {
            cartTotal() {
                return this.calculateCartTotal();
            },
            containerStyle(){
                return !Object.keys(this.cartItems).length ? 'filter:grayscale(100%); pointer-events:none; user-select: none;' : '';
            }
        },

        methods: {
            calculateCartTotal() {
                if (!Object.keys(this.cartItems).length) return 0;

                return Object.keys(this.cartItems).map(key => {
                    return parseFloat(this.cartItems[key].current_donation) || 0;
                }).reduce((total, key) => {
                    return total + key;
                });
            },

            buildCheckoutItems() {
                if (!Object.keys(this.cartItems).length) return null;

                return Object.keys(this.cartItems).map(key => {
                    return {
                        name: key,
                        price: this.cartItems[key].current_donation || 0,
                        quantity: 1,
                        currency: 'USD',
                    }
                });
            },

            buildPaymentPostData() {
                return {
                    totalAmount: this.calculateCartTotal(),
                    items: this.buildCheckoutItems(),
                }
            },

            confirmAndProcessPayment(data) {
                return new Promise((resolve, reject) => {
                    axios.post(
                        window.App.globalData.routes.checkout.payment.execute,
                        data
                    ).then(response => {
                        console.log(response);
                        return resolve(response);
                    }).catch((error) => {
                        console.log(error);
                        return reject(error);
                    })
                });
            },

            validateCartIsEmpty(actions){
                if(!Object.keys(this.cartItems).length){
                    this.$notify({
                        title: 'Error',
                        message: "The cart is empty, First browse and select at least one classroom to fund",
                        type: 'info'
                    });
                    return actions.disable();
                }
                return actions.enable() ;
            }
        },

        mounted() {
            let vm = this;
            paypal.checkout.setup()
            paypal.Button.render({
                env: window.App.paypal.environment,
                commit: true,
                locale:'en_US',
                client: vm.paypalClient,
                style: vm.paypalStyling,
                funding: vm.paypalFunding,

                payment: function (actions) {
                    return actions.payment.create({
                        transactions: [{
                            amount: {
                                total: vm.cartTotal,
                                currency: 'USD',
                            },
                            description: vm.paypalTransactionDescription,
                            payment_options: {
                                allowed_payment_method: 'INSTANT_FUNDING_SOURCE'
                            },
                            item_list: {
                                items: vm.buildCheckoutItems(),
                            }
                        }],
                    });
                },
                onAuthorize: function (data, actions) {

                    console.log(data)
                    let loading = vm.$loading();

                    vm.confirmAndProcessPayment({
                        paymentToken: data.paymentToken,
                        paymentID: data.paymentID,
                        payerID: data.payerID,
                        cartId: vm.cartId,
                        //totalAmount:vm.cartTotal,
                    }).then((res) => {
                        loading.close();
                        // console.log(res);
                        // console.log('move user to next step');
                        kinfEvents.$emit('PaymentSuccess', res);
                    }).catch(err => {
                        loading.close();
                        //console.log(err)
                        // console.log('display error')
                        kinfEvents.$emit('PaymentError', err);
                    });
                }
            }, '#paypal-button-container');
        }

    }
</script>

<template>
    <div id="paypal-button-container" :style="containerStyle"></div>
</template>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/PayPalDonateBtn.vue